// extracted by mini-css-extract-plugin
export default {"header-lagre":"style_header-lagre__TpbUG","header-lagre__custom-bg":"style_header-lagre__custom-bg__9LxJy"};